import { Middleware } from "redux";
import { ConversationStep } from "../../interfaces";
import { chatActions } from "../chat/slice";
import { v4 } from "uuid";

import * as _ from "lodash";
import { trackEvent } from "../analytics/action";
const { REACT_APP_WEBSOCKET_URL, REACT_APP_STAGE } = process.env;

let wsTimeout: any = null;
let socket: WebSocket;

const sendToWebsocket = (chatId: string, connectionId: string, step: ConversationStep) => {
    socket?.send(
        JSON.stringify({
            Entries: [
                {
                    Detail: {
                        ...step,
                        idChat: `${step.theme?.apiKey}-${chatId}`,
                        apiKey: step.theme?.apiKey,
                        connectionId,
                    },
                    DetailType: `chatapp.to.tunnel`,
                    EventBusName: `mp-global-exchange-${REACT_APP_STAGE}`,
                    Source: `mp-chatapp-${REACT_APP_STAGE}`,
                    Time: new Date(),
                },
            ],
        })
    );
};

const chatMiddleware: Middleware = (store) => (next) => (action) => {
    const isConnectionEstablished = store.getState().chat.isConnected;
    const connectionId = store.getState().chat.connectionId;
    const chatId = store.getState().chat.chatId;
    const messages = store.getState().chat.messages;

    if (chatActions.startConnecting.match(action)) {
        // socket = new WebSocket(REACT_APP_WEBSOCKET_URL!);

        if (socket) {
            socket.onopen = () => {
                store.dispatch(chatActions.connectionEstablished());
            };

            socket.onmessage = (ev) => {
                const data = JSON.parse(ev.data);

                if (data?.type === "connectionId") {
                    store.dispatch(
                        chatActions.setConnectionId({ connectionId: data.connectionId })
                    );
                } else {
                    const body = data?.Detail;

                    if (body?.responseType) {
                        clearTimeout(wsTimeout);
                        if (
                            body?.message?.type === "status" &&
                            body?.message?.text?.includes("joined the conversation")
                        ) {
                            store.dispatch(
                                //@ts-ignore
                                trackEvent({
                                    livechat: {
                                        assignedAgent: body?.assignedAgent?.name || "",
                                    },
                                })
                            );
                        }
                        store.dispatch(
                            chatActions.receiveMessage({
                                message: {
                                    ...body,
                                    id: body?.idChat,
                                    type: body?.type,
                                    ...(body?.message?.type === "status"
                                        ? {
                                              status: body?.message?.text,
                                          }
                                        : {
                                              message: body?.message?.text,
                                          }),
                                },
                            })
                        );
                    }
                }
            };
        }
    }

    if (chatActions.sendToCMS.match(action)) {
        // const hasUser =
        //   !_.isEmpty(action.payload.message?.user?.firstName) &&
        //   !_.isEmpty(action.payload.message?.user?.lastName) &&
        //   !_.isEmpty(action.payload.message?.user?.email);

        // const isLivechatEnabled = store.getState()?.chat?.isLivechatEnabled;
        const index = _.findLastIndex(
            messages,
            (m: ConversationStep) => m.id === action.payload.message.id
        );
        const isLast = index === messages.length - 1;

        //sends new message to cms
        if (
            !isLast &&
            (action.payload.message.message ||
                action.payload.message.video ||
                action.payload.message.component ||
                action.payload.message.options ||
                action.payload.message.input)
        ) {
            const message = action.payload.message;
            store.dispatch(chatActions.addMessage({ message }));

            // if (isLivechatEnabled) {
            //     if (message?.wait) {
            //         wsTimeout = setTimeout(() => {
            //             store.dispatch(
            //                 chatActions.addMessage({
            //                     message: {
            //                         id: v4(),
            //                         type: "bot",
            //                         escalated:
            //                             action.payload.message.escalated ||
            //                             store.getState().chat?.chatHasBeenEscalated,
            //                         theme: action.payload.message?.theme,
            //                         message: "Just giving the team a nudge, give me a second!",
            //                         trigger: "team-exprt-away",
            //                     },
            //                 })
            //             );
            //         }, action.payload.message.wait);
            //     }

            //     sendToWebsocket(chatId, connectionId, action.payload.message);
            // }
        }
    }
    console.log("NEXT!", action);
    next(action);
};

export default chatMiddleware;
